export function isNullishOperator(op: string): boolean {
  return op === 'is_null' || op === 'is_not_null';
}

export function isListOperator(op: string): boolean {
  return op === 'in' || op === 'not_in';
}

/**
 * Parse a raw input string into the correct typed value for the condition.
 * - List operators (in/not_in): split by comma into an array
 * - Numeric strings: store as a number
 * - Everything else: store as a string
 */
export function parseConditionValue(raw: string, operator: string): unknown {
  if (isListOperator(operator)) {
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  const trimmed = raw.trim();
  const asNum = Number(trimmed);
  return trimmed !== '' && !isNaN(asNum) ? asNum : raw;
}

/** Format a stored condition value back into a display string. */
export function formatConditionValue(value: unknown): string {
  if (Array.isArray(value)) return value.join(', ');
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'bigint'
  ) {
    return String(value);
  }
  return JSON.stringify(value) ?? '';
}
